import { modal } from 'bold-ui'
import { FormErrorModel, ValidationErrorsModal } from 'components/modals/fields-summary'
import { ErrorObject } from 'util/validation'
import { meta, SoapState } from 'view/atendimentos/atendimento-individual/model'

import { soapValidationErrorModalConfig } from '../soapFieldModalConfigs'
import { soapFormLabels } from '../soapFormLabels'

interface ValidationErrorsModalOptions {
  errors: Readonly<ErrorObject<SoapState> & FormErrorModel>
  onClose?: () => void
}

export function showValidationErrorsSoapModal(options: ValidationErrorsModalOptions) {
  const { errors, onClose } = options

  return modal({
    title: 'Para finalizar o atendimento, é necessário corrigir o(s) registro(s):',
    icon: {
      name: 'banOutline',
      fill: 'danger',
    },
    size: 'large',
    render: () => (
      <ValidationErrorsModal<SoapState>
        errors={errors}
        labels={soapFormLabels}
        config={soapValidationErrorModalConfig}
        meta={meta}
      />
    ),
    onClose: () => onClose?.(),
  })()
}
